// src/tracker/components/ConfirmationDialog.js

import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

const ConfirmationDialog = ({ open, options, onCancel, onConfirm }) => {
    // Set default values for title and message if they are not provided
    const { title = 'Confirm Action', message = 'Are you sure?' } = options;

    return (
        <Dialog open={open} onClose={onCancel} aria-labelledby="confirmation-dialog-title">
            <DialogTitle id="confirmation-dialog-title">{title}</DialogTitle>
            <DialogContent>
                <DialogContentText>{message}</DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onCancel}>Cancel</Button>
                <Button onClick={onConfirm} color="primary" autoFocus>
                    Confirm
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmationDialog;